import { EditableCell } from './editable-cell';
import { AritoInputTableColumn } from './types';
import { FormMode } from '@/types/form';

interface BuildAritoInputTableColumnsArgs {
  columns: AritoInputTableColumn[];
  mode: FormMode;
  updateCellValue: (rowId: string, field: string, nextValue: unknown) => void;
}

export const buildAritoInputTableColumns = ({
  columns,
  mode,
  updateCellValue
}: BuildAritoInputTableColumnsArgs): AritoInputTableColumn[] =>
  columns.map(column => {
    const isEditable =
      mode !== 'view' &&
      column.field !== 'checkbox' &&
      column.renderCell === undefined &&
      column.nonWritable !== true &&
      (column.editable ?? true);

    return {
      ...column,
      sortable: column.sortable ?? true,
      renderCell: (params: any) => {
        if (column.field === 'checkbox') {
          return (
            <div className='flex h-full w-full items-center justify-center'>
              <input
                type='checkbox'
                className='h-4 w-4'
                checked={Boolean(params.value)}
                disabled={mode === 'view'}
                onChange={event => {
                  event.stopPropagation();
                  updateCellValue(params.id, column.field, event.target.checked);
                }}
              />
            </div>
          );
        }

        if (column.renderCell) {
          return column.renderCell(params);
        }

        if (!isEditable) {
          return params.formattedValue ?? params.value ?? '';
        }

        return (
          <EditableCell
            value={params.value}
            onCommit={nextValue => updateCellValue(params.id, column.field, nextValue)}
          />
        );
      }
    };
  });
